@let engineerTracking = this.engineerTracking();
@let directionsLeg = this.directionsLeg();
@let showInformation = this.showInformation();

<div class="position-absolute bottom-0 start-50 translate-middle-x mb-4 px-3 w-100" style="max-width: 350px">
    <div class="card shadow bg-light border-2 border-warning">
        <div class="card-body text-center d-flex flex-column gap-3">
            @if (showInformation) {
                @if (engineerTracking.engineerPicture) {
                    <img
                        [src]="engineerTracking.engineerPicture"
                        class="rounded-circle mx-auto border border-3 border-warning"
                        width="100"
                        height="100"
                        alt="Engineer Image" />
                }

                <h5 class="card-title text-dark m-0">{{ engineerTracking.engineerName }}</h5>

                <div class="d-flex flex-column gap-2">
                    @if (engineerTracking.engineerGasSafeNumber || engineerTracking.engineerVehicleReg) {
                        <div class="alert alert-info py-2 px-3 d-flex flex-column gap-2 small mb-2">
                            @if (engineerTracking.engineerGasSafeNumber) {
                                <div class="d-flex align-items-center justify-content-center">
                                    <fa-icon [icon]="['fas', 'id-badge']" class="me-2 text-primary"></fa-icon>
                                    Gas Safe Number:
                                    <strong class="ms-1">{{ engineerTracking.engineerGasSafeNumber }}</strong>
                                </div>
                            }

                            @if (engineerTracking.engineerVehicleReg) {
                                <div class="d-flex align-items-center">
                                    <fa-icon [icon]="['fas', 'car']" class="me-2 text-primary"></fa-icon>
                                    Vehicle Reg:
                                    <strong class="ms-1">{{ engineerTracking.engineerVehicleReg }}</strong>
                                </div>
                            }
                        </div>
                    }

                    @if (directionsLeg) {
                        <span class="badge bg-success d-flex align-items-center small">
                            <fa-icon [icon]="['fas', 'road']" class="me-2 text-white"></fa-icon>
                            Distance:
                            <strong class="ms-1">{{ directionsLeg.miles }} Miles</strong>
                        </span>

                        <span class="badge bg-success d-flex align-items-center small">
                            <fa-icon [icon]="['fas', 'clock']" class="me-2 text-white"></fa-icon>
                            ETA:
                            <strong class="ms-1">{{ directionsLeg.time }}</strong>
                        </span>
                    }

                    <span class="badge bg-success d-flex align-items-center small">
                        <fa-icon [icon]="['fas', 'location-dot']" class="me-2 text-white"></fa-icon>
                        Postcode:
                        <strong class="ms-1">{{ engineerTracking.customerPostcode }}</strong>
                    </span>
                </div>

                <div class="alert alert-warning py-2 small m-0" role="alert">
                    You can pay by <strong>cash</strong> or <strong>card</strong>
                </div>
            }

            <div class="d-flex gap-2">
                @if (engineerTracking.companyPhoneNumber) {
                    <a
                        sfButton
                        type="button"
                        color="primary"
                        size="sm"
                        href="tel:{{ engineerTracking.companyPhoneNumber | phoneNumber }}"
                        icon="phone"></a>
                }

                <button
                    sfButton
                    type="button"
                    color="primary"
                    size="sm"
                    class="w-100"
                    (click)="toggleShowInformation()">
                    {{ showInformation ? 'Hide' : 'Show' }} Engineer Info
                </button>
            </div>
        </div>
    </div>
</div>
